<template>
	<v-container grid-list-xl>
		<v-layout row wrap>      
			<v-flex lg6>			
				<label class="blackLabel">Currency:</label>
				<v-select @input="fncCheckForex" :items="currency" v-model="currencyCurrency" label="Currency" autocomplete solo></v-select>
			</v-flex>
			<v-flex lg6>
				<label class="blackLabel">Value:</label>
              <v-text-field v-model="currencyRate" label="Value" solo></v-text-field>
			</v-flex>
			<v-flex lg6>
				<label class="blackLabel">Tax Label</label>
              <v-text-field v-model="taxLabel" label="Tax Label" solo></v-text-field>
			</v-flex>
			<v-flex lg6>
				<label class="blackLabel">Tax Rate:</label>
              <v-text-field v-model="taxRate" label="Tax Rate" solo></v-text-field>
			</v-flex>
			<div class="pl-4 pr-1 pb-4 buttonHolder">
				<div style="float: right">
					<v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Close</v-btn>
					<v-btn color="success" class="text-xs-right" @click.stop="fncUpdateForex()">Update</v-btn>
                    <small>&nbsp;</small>
				</div>	
			</div>		
			<v-flex lg12 class="requiredMessage">
				&nbsp;
			</v-flex>			
		</v-layout>
	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex';
	
	export default {
	  name: 'Settings',
	  data () {
			return {
              currencyCurrency: '',              
              currentCurency: '',
              taxLabel: '',
              taxRate: '0.00',
              currency: [
                { id: '$', text: 'USD' }, 
                { id: 'R', text: 'ZAR' }, 
                { id: '£', text: 'GBP' }, 
                { id: '€', text: 'EUR' } 
              ]
			};
		},		
      methods: {
          fncCheckForex() {
            if (this.currencyCurrency != 'ZAR') {
              this.taxRate = '0.00';
              this.taxLabel = '';
            } else {
              this.taxRate = '15.00';
              this.taxLabel = 'VAT';
            }
            this.$store.dispatch({
              type: 'fncCheckForex',
              quoteId: this.globalModalParams.quoteId,
              //currentCurrency: this.globalModalParams.quoteId
              currency: this.currencyCurrency.text,
              currencyOverride: this.globalModalParams.currencyType == null ? 'ZAR' : this.globalModalParams.currencyType 
            })
          },
          fncHideModal() {
            this.$store.commit('hideModal');
          },
          fncUpdateForex() {
            this.$store.dispatch({
              type: 'fncUpdateForex',
              quoteId: this.globalModalParams.quoteId,
              overrideCurrencySym: this.currencyCurrency.id,
              overrideCurrencyCode: this.currencyCurrency.text,
              overrideExchangeRate: this.currencyRate,
              overrideTaxLabel: this.taxLabel,
              overrideTaxRate: this.taxRate
              })            
          }
		},
		computed: {
			...mapGetters([			
				'objAuthorize',				
                'globalModalParams',
                'currencyRate'
			])
		}
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>